import http from "./http";

export const GetMyTransactions = async (params) =>
  await http.get("/transaction/me", {params});
